import { render, staticRenderFns } from "./ModalAddEditRole.vue?vue&type=template&id=8b2d64b4&lang=html&"
import script from "./ModalAddEditRole.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports